(function() {
    'use strict';

    angular.module('user')
        .controller('LoginBarcodeController', LoginBarcodeController);

    LoginBarcodeController.$inject = ['userAuthService'];

    function LoginBarcodeController(userAuthService) {
        var self = this;

        self.credentials = {
            barcode: ''
        };

        self.serverErrors = {
            barcode: [],
            nonFieldErrors: []
        };

        self.login = userAuthService.login;
    }
})();
